module.exports = __webpack_public_path__ + "static/media/PC4-5-2.49cb258f.jpg";